import * as i18n from 'i18next';
import { Device, DeviceId, EcsDevice } from 'shared/models';

const DISPLAY_NAME_MAX_LENGTH = 32;

// Rename devices in an elevator group based on the name of the elevator.
// Ideally, we want the device name to be "<elevator name> <device type>"
// such as "PE #4 Display" and "PE #4 Camera" (for elevator "PE #4").
// However, some users enter very long names for the elevators, which
// causes the resultant device names to exceed the database column length
// (32 chars). So, when generating device names here, we ensure the final
// length is at most 32 characters.
export const renameDevices = (elevatorName: string | null, devices: Record<DeviceId, Device | EcsDevice>, t: i18n.TFunction): Record<DeviceId, string | null> => {
    const result: Record<DeviceId, string | null> = {};
    for (const deviceId of Object.keys(devices)) {
        const device = devices[deviceId];
        let newDisplayName = null;
        if (elevatorName) {
            const stringKey = `SETUP.CLASS.${device.deviceClass.toUpperCase()}`;
            const availableLength = DISPLAY_NAME_MAX_LENGTH - t(stringKey, [ '' ]).length;
            newDisplayName = t(stringKey, [ elevatorName.substring(0, availableLength) ]);
        }
        result[deviceId] = newDisplayName;
    }
    return result;
};
